import { useState, useEffect } from 'react';

interface DeviceInfo {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  isTouchDevice: boolean;
  userAgent: string;
}

export function useDeviceDetection(): DeviceInfo {
  const [deviceInfo, setDeviceInfo] = useState<DeviceInfo>(() => {
    if (typeof window === 'undefined') {
      return {
        isMobile: false,
        isTablet: false,
        isDesktop: true,
        isTouchDevice: false,
        userAgent: '',
      };
    }

    const userAgent = navigator.userAgent.toLowerCase();
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    
    // Mobile detection
    const mobileRegex = /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i;
    const isMobile = mobileRegex.test(userAgent) || (window.innerWidth <= 768);
    
    // Tablet detection
    const tabletRegex = /ipad|android(?!.*mobile)|tablet/i;
    const isIPadOS = /macintosh/i.test(userAgent) && navigator.maxTouchPoints > 1;
    const isTablet = isIPadOS || tabletRegex.test(userAgent) || (window.innerWidth > 768 && window.innerWidth <= 1024 && isTouchDevice);
    
    const isDesktop = !isMobile && !isTablet;

    return {
      isMobile,
      isTablet,
      isDesktop,
      isTouchDevice,
      userAgent,
    };
  });

  useEffect(() => {
    const handleResize = () => {
      const userAgent = navigator.userAgent.toLowerCase();
      const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      
      const mobileRegex = /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i;
      const isMobile = mobileRegex.test(userAgent) || (window.innerWidth <= 768);
      
      const tabletRegex = /ipad|android(?!.*mobile)|tablet/i;
      const isIPadOS = /macintosh/i.test(userAgent) && navigator.maxTouchPoints > 1;
    const isTablet = isIPadOS || tabletRegex.test(userAgent) || (window.innerWidth > 768 && window.innerWidth <= 1024 && isTouchDevice);
      
      const isDesktop = !isMobile && !isTablet;

      setDeviceInfo({
        isMobile,
        isTablet,
        isDesktop,
        isTouchDevice,
        userAgent,
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return deviceInfo;
}
